import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useDebounce } from "use-debounce";
import { clearTopic, getTopicStart } from "../../redux/auto-complete/reducer";
import { selectTopicList } from "../../redux/auto-complete/selectors";

const useTopicsGet = ({ searchKey }) => {
  const [selectedSuggestion, setSelectedSuggestion] = useState("");
  const [topic, setTopic] = useState("");
  const [debouncedSearchText] = useDebounce(topic, 400);
  const dispatch = useDispatch();
  const topics = useSelector(selectTopicList);

  const fetchTopics = useCallback(() => {
    dispatch(getTopicStart({ searchText: debouncedSearchText, searchKey }));
  }, [debouncedSearchText, searchKey, dispatch]);

  const resetTopic = () => {
    dispatch(clearTopic());
  };
  const onTopicChange = (text) => {
    setTopic(text);
  };

  const onTopicSelect = (value) => {
    setTopic(value);
    setSelectedSuggestion(value);
  };

  useEffect(() => {
    if (topic.length >= 3 && topic !== selectedSuggestion) {
      fetchTopics();
    }
    // eslint-disable-next-line
  }, [fetchTopics]);

  return {
    topicList: topics,
    topic,
    setTopic,
    onTopicChange,
    onTopicSelect,
    resetTopic,
  };
};

export default useTopicsGet;
